import React from 'react';
import SlimHero from '../ui/hero/hero-slim';
import LocalNews from '../ui/local-news/local-news';
import mockLocalNews from '../mocks/local-news.json';

export default ({ match }) => {
  const pageTitle = "News";
  return <>
    <SlimHero title={pageTitle}/>
    <div className="row">
        <LocalNews news={mockLocalNews} />
    </div>
  </>
}
